import React, { useState } from 'react';
import { makeStyles, List, ListItem, ListItemText } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import { HelpCircle as SupportIcon } from 'react-feather';
import FAQS from './faqs';
import Suggestion from './suggestion';
import {
  ContactSupport as FaqsIcon,
  SettingsPhone as ContactIcon,
  Assignment as TicketIcon,
  Loyalty as SuggestionIcon,
  Chat as ChatIcon
} from '@material-ui/icons';
import { useSelector, useDispatch } from 'src/store';
import { switchToggle, closeToggle } from 'src/slices/toggle';
import useAuth from 'src/hooks/useAuth';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#fff',
    border: 'solid 1px #e0e0e0',
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    right: '22px',
    bottom: '65px',
    webkitBoxShadow: '0 2px 4px rgba(0,0,0,.1), 0 0 0 1px rgba(0,0,0,.05)',
    '&.MuiList-padding': {
      paddingTop: '0px',
      paddingBottom: '0px'
    }
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    width: '500px'
  },
  supportBtn: {
    right: '2px',
    bottom: '0px',
    position: 'absolute'
  },
  listItem: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e0e0e0'
    }
  },
  listIcon: {
    marginRight: '5px'
  }
}));

const Support = () => {
  const { user } = useAuth();
  const userFullName = `${user.userFirstName} ${user.userLastName}`;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { hidden: showPop } = useSelector((state) => state.toggle);
  const [drawer, toggleDrawer] = useState(false);
  const [suggestModal, setSuggestModal] = useState(false);

  const handleOpenDrawer = () => {
    dispatch(closeToggle());
    toggleDrawer(true);
  };
  const handleCloseDrawer = () => {
    toggleDrawer(false);
  };

  const toggleSupport = (event) => {
    event.stopPropagation();
    dispatch(switchToggle());
  };

  const handleCloseModal = () =>{
    setSuggestModal(false)
  }
  const handleOpenModal = () =>{
    setSuggestModal(true)
  }
  return (
    <div className={classes.fab}>
      {!showPop && (
        <List className={classes.root}
        >
          {/* <a href="javascript:void(Tawk_API.toggle())"> */}
          <ListItem  className={classes.listItem} onClick={()=>{Tawk_API.toggle()}}>
            <ChatIcon className={classes.listIcon} />
            Chat With Us
          </ListItem>
           {/* </a> */}
          <ListItem onClick={handleOpenDrawer} className={classes.listItem}>
            <FaqsIcon className={classes.listIcon} />
            FAQs
          </ListItem>
          {/* <ListItem className={classes.listItem}>
            <TicketIcon className={classes.listIcon} />
            Open/Manage Ticket
          </ListItem> */}
          <ListItem onClick={handleOpenModal} className={classes.listItem}>
            <SuggestionIcon className={classes.listIcon} />
             Suggest an improvement
          </ListItem>
          <ListItem
            onClick={() =>
              zE(function () {
                zE.activate({ hideOnClose: true });
                zE.identify({
                  name: userFullName,
                  email: user.userEmail
                });
              })
            }
            className={classes.listItem}
          >
            <ContactIcon className={classes.listIcon} />
            Contact Us
          </ListItem>
        </List>
      )}
      <Fab
        variant="extended"
        onClick={(e) => toggleSupport(e)}
        className={classes.supportBtn}
      >
        <SupportIcon className={classes.extendedIcon} />
        Support
      </Fab>

      <FAQS onClose={handleCloseDrawer} open={drawer} />
      <Suggestion onClose={handleCloseModal} open={suggestModal} />
    </div>
  );
};

export default Support;
